import getUserElements from '../use-cases/get-user-elements'
import LoadingSpinner from 'components/common/LoadingSpinner'
import AppContext from 'context/AppContext'
import { Alert, Modal } from 'react-bootstrap'
import React, { useContext, useEffect, useState } from 'react'
import './UserMapper.scss'
import UserAllocation from './UserAllocation'
import UsersWithAccess from './UsersWithAccess'
import UsersWithNoAccess from './UsersWithNoAccess'
import RoleLevels from 'config/RoleLevels'
import Roles from 'config/Roles'

const UserMapper = (props) => {
  const { repoFactory, sorElements, selectedYear, sorElementMapping } = useContext(AppContext)
  const [allocationYear, setAllocationYear] = useState(selectedYear)
  const [isLoading, setIsLoading] = useState(true)
  const [usersWithNoBudget, setUsersWithNoBudget] = useState(null)
  const [usersWithBudget, setUsersWithBudget] = useState(null)
  const [error, setError] = useState(false)
  const [selectedUserForMapping, setSelectedUserForMapping] = useState(null)
  const [isSelectedUserNew, setIsSelectedUserNew] = useState(true)

  useEffect(() => {
    setAllocationYear(selectedYear)

    setUsersWithNoBudget(null)
    setUsersWithBudget(null)
  }, [selectedYear, setAllocationYear, setUsersWithNoBudget, setUsersWithBudget])

  useEffect(() => {
    getAllUserElements()
  }, [allocationYear, repoFactory])

  const getAllUserElements = () => {
    setIsLoading(true)
    getUserElements(
      {
        allocationYear,
        roles: Roles,
        roleLevels: RoleLevels
      },
      {
        userMapperRepo: repoFactory.userMapperRepo(),
        observer: {
          receiveUsersDetails: ({ usersWithNoBudget, usersAndTheirBudget }) => {
            setIsLoading(false)
            setUsersWithNoBudget(usersWithNoBudget)
            setUsersWithBudget(usersAndTheirBudget)
          },
          errorGettingData: () => {
            setIsLoading(false)
            setUsersWithNoBudget(null)
            setUsersWithBudget(null)
            setError(true)
          }
        }
      }
    )
  }

  const mapSelectedUser = ({ selectedUser, isNew }) => {
    setSelectedUserForMapping(selectedUser)
    setIsSelectedUserNew(isNew)
  }

  const updateMappingForUser = (selectedUser) => {
    mapSelectedUser({
      selectedUser,
      isNew: false
    })
  }

  return (
    <>
      {!!sorElements && (
        <div id="user-access-to-budgets">
          {isLoading && <LoadingSpinner />}
          {error && <Alert variant="danger">Error getting accounts</Alert>}

          {usersWithNoBudget && (
            <UsersWithNoAccess
              usersWithNoBudget={usersWithNoBudget}
              isNewUser={isSelectedUserNew}
              selectedUserForMapping={selectedUserForMapping}
              repoFactory={repoFactory}
              sorElements={sorElements}
              allocationYear={allocationYear}
              getAllUserElements={getAllUserElements}
            />
          )}

          {usersWithBudget && (
            <>
              <hr />
              <UsersWithAccess
                usersWithBudget={usersWithBudget}
                sorElementMapping={sorElementMapping}
                allocationYear={allocationYear}
                setUserForMapping={(item) => {
                  updateMappingForUser(item.rawRowData)
                }}
                getAllUserElements={getAllUserElements}
                {...props}
              />
            </>
          )}

          <Modal
            show={selectedUserForMapping}
            onHide={() => {
              setIsSelectedUserNew(false)
              setSelectedUserForMapping(false)
            }}
            size="xl"
          >
            <Modal.Body>
              <h2>Re-Apply User Management</h2>
              <UserAllocation
                repoFactory={repoFactory}
                selectedUser={selectedUserForMapping}
                isNew={isSelectedUserNew}
                sorElements={sorElements}
                allocationYear={allocationYear}
                setSelectedUserForMapping={setSelectedUserForMapping}
                setIsSelectedUserNew={setIsSelectedUserNew}
              />
            </Modal.Body>
          </Modal>
        </div>
      )}
    </>
  )
}

export default UserMapper
